import { handleActions, combineActions } from 'redux-actions'
import { fromJS, Set } from 'immutable'

import * as Actions from 'actions/journalists'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  animateSearchBtn: false,
  moduleReady: false,
  requestRunning: false,
  importJournalistRequestRunning: false,
  fetchPublicationsRequestRunning: false,
  fetchNewsRequestRunning: false,
  searchDlRequestRunning: false,
  searchJobTitlesRequestRunning: false,
  simpleSearch: true,
  detailPageJournalistId: null,
  distributionListsDialogOpen: false,
  distributionListsDialogJoIds: [],
  selectedJournalistIds: [],
  selectedDistributionLists: [],
  newDistributionLists: [],
  pristine: true,
  showPersonFilters: true,
  showPublicationFilters: false,
  showTopicHelperText: false,
  iptcMediaTopicsDialogOpen: false,
  iptcMediaTopics: {
    searchQuery: '',
    searchInDefinitions: false,
    expandedIds: Set([])
  }
})

export default handleActions({
  [Actions.setSimple]: state => state.set('simpleSearch', true),
  [Actions.setAdvanced]: state => state.set('simpleSearch', false),

  [combineActions(
    Actions.searchJournalistsStart,
    Actions.setPagination,
    Actions.setMyContactsPagination
  )]: state => state
    .set('requestRunning', true)
    .set('pristine', false),
  [Actions.searchJournalistsSuccess]: state => (
    state.set('requestRunning', false).set('simpleSearch', false).set('showTopicHelperText', false)
  ),
  [Actions.searchJournalistsError]: state => state.set('requestRunning', false),

  [combineActions(
    Actions.importJournalistsStart,
    Actions.importJournalistsToListStart
  )]: state => state.set('importJournalistRequestRunning', true),

  [combineActions(
    Actions.importJournalistsSuccess,
    Actions.importJournalistsError,
    Actions.importJournalistsToListSuccess,
    Actions.importJournalistsToListError
  )]: state => state.set('importJournalistRequestRunning', false),
  [Actions.openJournalistDetails]: (state, { payload }) => state.set('detailPageJournalistId', payload),
  [Actions.closeJournalistDetails]: state => state.set('detailPageJournalistId', null),

  [Actions.loadJournalistNewsStart]: state => state.set('fetchNewsRequestRunning', true),
  [combineActions(
    Actions.loadJournalistNewsSuccess,
    Actions.loadJournalistNewsError
  )]: state => state.set('fetchNewsRequestRunning', false),

  [Actions.searchDistributionListsStart]: state => state.set('searchDlRequestRunning', true),
  [combineActions(
    Actions.searchDistributionListsSuccess,
    Actions.searchDistributionListsError
  )]: state => state.set('searchDlRequestRunning', false),

  [Actions.fetchPublicationsStart]: state => state.set('fetchPublicationsRequestRunning', true),
  [combineActions(
    Actions.fetchPublicationsSuccess,
    Actions.fetchPublicationsError
  )]: state => state.set('fetchPublicationsRequestRunning', false),

  [Actions.searchJobTitlesStart]: state => state.set('searchJobTitlesRequestRunning', true),
  [combineActions(
    Actions.searchJobTitlesSuccess,
    Actions.searchJobTitlesError
  )]: state => state.set('searchJobTitlesRequestRunning', false),

  [Actions.toggleJournalistId]: (state, { payload }) => {
    const selectedJournalistIds = state.get('selectedJournalistIds')
    const index = selectedJournalistIds.indexOf(payload)

    if (index === -1) {
      return state.set('selectedJournalistIds', selectedJournalistIds.push(payload))
    }

    return state.set('selectedJournalistIds', selectedJournalistIds.delete(index))
  },
  [Actions.resetJournalistIds]: state => state.set('selectedJournalistIds', fromJS([])),

  [combineActions(
    Actions.importJournalistsSuccess,
    Actions.importJournalistsToListSuccess
  )]: state => state
    .set('selectedJournalistIds', fromJS([]))
    .set('selectedDistributionLists', fromJS([])),

  [Actions.openDistributionListsDialog]: state => state.set('distributionListsDialogOpen', true),
  [Actions.closeDistributionListsDialog]: state => state.set('distributionListsDialogOpen', false),

  [Actions.openIptcMediaTopicsDialog]: state => state.set('iptcMediaTopicsDialogOpen', true),
  [Actions.closeIptcMediaTopicsDialog]: (state, { payload }) => state
    .set('iptcMediaTopicsDialogOpen', false)
    .set('showTopicHelperText', payload),

  [Actions.setDistributionListsDialogJoIds]: (state, { payload }) => state.set('distributionListsDialogJoIds', fromJS(payload)),
  [Actions.setSelectedDistributionLists]: (state, { payload }) => state.set('selectedDistributionLists', fromJS(payload)),
  [Actions.setNewDistributionLists]: (state, { payload }) => state.set('newDistributionLists', fromJS(payload)),

  [Actions.setIptcMediaTopics]: (state, { payload }) => {
    const { key, value } = payload

    if (key === 'expandedIds') {
      return state.setIn(['iptcMediaTopics', key], Set(value))
    }

    return state.setIn(['iptcMediaTopics', key], value)
  },

  [Actions.setAnimateSearchBtn]: (state, { payload }) => state.set('animateSearchBtn', payload),
  [Actions.setShowTopicHelperText]: (state, { payload }) => state.set('showTopicHelperText', payload),

  [Actions.setSelectedJournalistIds]: (state, { payload }) => state.set('selectedJournalistIds', payload),
  [AppActions.resetState]: () => initialState
}, initialState)

